import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { updateCurrentDateAuto } from '../../redux/actions/action-creator';
import { shouldUpdateDate, getLastUpdateDate, setLastUpdateDate } from '../../utils/dateUtils';

const useAutoDateUpdate = () => {
    const dispatch = useDispatch();
    const lastUpdateRef = useRef(null);

    useEffect(() => {
        const updateDateIfNeeded = () => {
            const lastUpdateDate = getLastUpdateDate();
            
            // Check if we need to update the date
            if (shouldUpdateDate(lastUpdateDate)) {
                dispatch(updateCurrentDateAuto());
                setLastUpdateDate();
                lastUpdateRef.current = new Date().toDateString();
            }
        };

        // Update date on component mount
        updateDateIfNeeded();

        // Set up interval to check every hour (in case user keeps app open overnight)
        const interval = setInterval(updateDateIfNeeded, 60 * 60 * 1000); // 1 hour

        // Cleanup interval on unmount
        return () => clearInterval(interval);
    }, [dispatch]);

    return null;
};

export default useAutoDateUpdate; 